/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_S1_DInputs */

const en_mk_abt_s1_d = /** @type {(inputs: Mk_Abt_S1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The issue tracker, team chat, agents with 19 tools, approvals, memory, routines and billing are all running and covered by automated release gates.`)
};

const id_mk_abt_s1_d = /** @type {(inputs: Mk_Abt_S1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue tracker, chat tim, agen dengan 19 alat, approval, memori, rutinitas, dan tagihan sudah berjalan dan diuji otomatis setiap rilis.`)
};

/**
* | output |
* | --- |
* | "The issue tracker, team chat, agents with 19 tools, approvals, memory, routines and billing are all running and covered by automated release gates." |
*
* @param {Mk_Abt_S1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_s1_d = /** @type {((inputs?: Mk_Abt_S1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_S1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_s1_d(inputs)
	return en_mk_abt_s1_d(inputs)
});